'use client';

import { useNativeTokens } from '~/(tenant)/_components/native/_lib/use-native-tokens';

/**
 * Hairline ornament: ──•── using current tokens. Used as a separator above
 * pull-quotes and at the top of editorial empty states.
 */
export function Ornament() {
  const t = useNativeTokens();
  return (
    <svg
      width="40"
      height="8"
      viewBox="0 0 40 8"
      style={{ display: 'block', margin: '0 auto' }}
      aria-hidden
    >
      <line x1="0" y1="4" x2="16" y2="4" stroke={t.line} strokeWidth="0.7" />
      <circle cx="20" cy="4" r="1.6" fill={t.foreground} opacity="0.6" />
      <line x1="24" y1="4" x2="40" y2="4" stroke={t.line} strokeWidth="0.7" />
    </svg>
  );
}

/**
 * Concentric-arcs ornament. The "quiet" mark used for empty states —
 * carries Frame Studio's "rest is part of the practice" mood.
 */
export function QuietMark({ size = 120 }: { size?: number }) {
  const t = useNativeTokens();
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      style={{ display: 'block', margin: '0 auto' }}
      aria-hidden
    >
      <circle cx="60" cy="60" r="48" fill="none" stroke={t.foreground} strokeWidth="0.6" opacity="0.18" />
      <circle cx="60" cy="60" r="36" fill="none" stroke={t.foreground} strokeWidth="0.6" opacity="0.32" />
      <circle cx="60" cy="60" r="24" fill="none" stroke={t.foreground} strokeWidth="0.6" opacity="0.5" />
      <circle cx="60" cy="60" r="3" fill={t.foreground} opacity="0.7" />
    </svg>
  );
}
